/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FleetYards.net API
 * OpenAPI spec version: v1
 */
import {
  useMutation,
  useQuery
} from '@tanstack/vue-query';
import type {
  DataTag,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseMutationReturnType,
  UseQueryOptions,
  UseQueryReturnType
} from '@tanstack/vue-query';

import {
  computed,
  toValue,
  unref
} from 'vue';
import type {
  MaybeRefOrGetter
} from 'vue';

import type {
  FleetFidClaimStatus,
  SchemaValidationErrorResponse,
  StandardError,
  ValidationError
} from '../../models';

import { axiosClient } from '../../../axiosClient.ts';
import type { ErrorType } from '../../../axiosClient.ts';




/**
 * @summary Claim the FID equal to the fleet's verified RSI SID
 */
export const createFleetFidClaim = (
    fleetSlug: MaybeRefOrGetter<string>,
 signal?: AbortSignal
) => {
      fleetSlug = toValue(fleetSlug);

      return axiosClient<FleetFidClaimStatus>(
      {url: `/fleets/${fleetSlug}/fid-claim`, method: 'POST', signal
    },
      );
    }




export const getCreateFleetFidClaimMutationKey = () => ['createFleetFidClaim'] as const;

export const getCreateFleetFidClaimMutationOptions = <TError = ErrorType<ValidationError | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createFleetFidClaim>>, TError,CreateFleetFidClaimMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof createFleetFidClaim>>, TError,CreateFleetFidClaimMutationVariables, TContext> => {

const mutationKey = getCreateFleetFidClaimMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createFleetFidClaim>>, CreateFleetFidClaimMutationVariables> = (props) => {
          const {fleetSlug} = props ?? {};

          return  createFleetFidClaim(fleetSlug,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateFleetFidClaimMutationResult = NonNullable<Awaited<ReturnType<typeof createFleetFidClaim>>>

    export type CreateFleetFidClaimMutationError = ErrorType<ValidationError | StandardError>
    export type CreateFleetFidClaimMutationVariables = {fleetSlug: string}

    /**
 * @summary Claim the FID equal to the fleet's verified RSI SID
 */
export const useCreateFleetFidClaim = <TError = ErrorType<ValidationError | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createFleetFidClaim>>, TError,CreateFleetFidClaimMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof createFleetFidClaim>>,
        TError,
        CreateFleetFidClaimMutationVariables,
        TContext
      > => {
      return useMutation(getCreateFleetFidClaimMutationOptions(options), queryClient);
    }
    /**
 * @summary Withdraw the fleet's FID claim
 */
export const destroyFleetFidClaim = (
    fleetSlug: MaybeRefOrGetter<string>,
 signal?: AbortSignal
) => {
      fleetSlug = toValue(fleetSlug);

      return axiosClient<FleetFidClaimStatus>(
      {url: `/fleets/${fleetSlug}/fid-claim`, method: 'DELETE', signal
    },
      );
    }




export const getDestroyFleetFidClaimMutationKey = () => ['destroyFleetFidClaim'] as const;

export const getDestroyFleetFidClaimMutationOptions = <TError = ErrorType<ValidationError | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof destroyFleetFidClaim>>, TError,DestroyFleetFidClaimMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof destroyFleetFidClaim>>, TError,DestroyFleetFidClaimMutationVariables, TContext> => {

const mutationKey = getDestroyFleetFidClaimMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof destroyFleetFidClaim>>, DestroyFleetFidClaimMutationVariables> = (props) => {
          const {fleetSlug} = props ?? {};

          return  destroyFleetFidClaim(fleetSlug,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DestroyFleetFidClaimMutationResult = NonNullable<Awaited<ReturnType<typeof destroyFleetFidClaim>>>

    export type DestroyFleetFidClaimMutationError = ErrorType<ValidationError | StandardError>
    export type DestroyFleetFidClaimMutationVariables = {fleetSlug: string}

    /**
 * @summary Withdraw the fleet's FID claim
 */
export const useDestroyFleetFidClaim = <TError = ErrorType<ValidationError | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof destroyFleetFidClaim>>, TError,DestroyFleetFidClaimMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof destroyFleetFidClaim>>,
        TError,
        DestroyFleetFidClaimMutationVariables,
        TContext
      > => {
      return useMutation(getDestroyFleetFidClaimMutationOptions(options), queryClient);
    }
    /**
 * @summary Show the fleet's FID claims
 */
export const fleetFidClaim = (
    fleetSlug: MaybeRefOrGetter<string>,
 signal?: AbortSignal
) => {
      fleetSlug = toValue(fleetSlug);

      return axiosClient<FleetFidClaimStatus>(
      {url: `/fleets/${fleetSlug}/fid-claim`, method: 'GET', signal
    },
      );
    }




export const getFleetFidClaimQueryKey = (fleetSlug: MaybeRefOrGetter<string>,) => {
    return [
    'fleets',fleetSlug,'fid-claim'
    ] as const;
    }


export const getFleetFidClaimQueryOptions = <TData = Awaited<ReturnType<typeof fleetFidClaim>>, TError = ErrorType<SchemaValidationErrorResponse | StandardError>>(fleetSlug: MaybeRefOrGetter<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof fleetFidClaim>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getFleetFidClaimQueryKey(fleetSlug);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof fleetFidClaim>>> = ({ signal }) => fleetFidClaim(fleetSlug, signal);





   return  { queryKey, queryFn, enabled: computed(() => toValue(fleetSlug) !== null && toValue(fleetSlug) !== undefined), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof fleetFidClaim>>, TError, TData>
}

export type FleetFidClaimQueryResult = NonNullable<Awaited<ReturnType<typeof fleetFidClaim>>>
export type FleetFidClaimQueryError = ErrorType<SchemaValidationErrorResponse | StandardError>


/**
 * @summary Show the fleet's FID claims
 */

export function useFleetFidClaim<TData = Awaited<ReturnType<typeof fleetFidClaim>>, TError = ErrorType<SchemaValidationErrorResponse | StandardError>>(
 fleetSlug: MaybeRefOrGetter<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof fleetFidClaim>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getFleetFidClaimQueryOptions(fleetSlug,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






